import { render } from "./index.vue?vue&type=template&id=f26f3c10"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/appVersions/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f26f3c10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f26f3c10', __exports__)) {
    api.reload('f26f3c10', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f26f3c10", () => {
    api.rerender('f26f3c10', render)
  })

}


export default __exports__